var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordShowLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.5,472h-105c-22.056,0-40-17.944-40-40V268c0-22.056,17.944-40,40-40h288c22.056,0,40,17.944,40,40v21 c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20v-21c0-44.112-35.888-80-80-80h-24.037v-70.534 C360.463,52.695,306.631,0,240.463,0s-120,52.695-120,117.466V188H96.5c-44.112,0-80,35.888-80,80v164c0,44.112,35.888,80,80,80 h105c11.046,0,20-8.954,20-20C221.5,480.954,212.546,472,201.5,472z M160.463,117.466c0-42.715,35.888-77.466,80-77.466 s80,34.751,80,77.466V188h-160V117.466z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 346,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.864,403.503c-0.703-1.001-3.115-4.415-4.614-6.3c-6.696-8.422-22.376-28.146-44.193-45.558 C415.085,329.319,386.299,318,357.5,318s-57.585,11.319-85.556,33.643c-21.82,17.414-37.499,37.137-44.187,45.551 c-1.503,1.889-3.917,5.305-4.621,6.307c-4.847,6.898-4.848,16.096-0.002,22.994c0.705,1.003,3.119,4.421,4.617,6.302 c6.694,8.422,22.373,28.145,44.192,45.559C299.915,500.681,328.701,512,357.5,512s57.584-11.319,85.557-33.643 c21.817-17.413,37.498-37.136,44.196-45.562c1.498-1.885,3.908-5.296,4.611-6.297 C496.712,419.599,496.712,410.401,491.864,403.503z M357.5,472c-29.705,0-60.841-19.164-92.642-57 c31.799-37.835,62.935-57,92.642-57c29.703,0,60.843,19.169,92.643,57.001C418.342,452.835,387.206,472,357.5,472z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 346,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.5,
    cy: 415,
    r: 38
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShowLight);
export default __webpack_public_path__ + "static/media/PasswordShowLight.c045a5dd.svg";
export { ForwardRef as ReactComponent };